let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1ruJB"), load("6XHqm"), load("8zPpH")]).then(() => parcelRequire('35hhf'));